import { Typography } from "@mui/material";

import { formatWeightLb } from "../../utils";

export function ShipmentWeightText<T extends number>(
  props: ShipmentInfoTextProps<T>,
) {
  const { data } = props;

  const pounds = parseFloat(data.toString());

  if (pounds === 0 || Number.isNaN(pounds)) {
    return null;
  }

  const text = formatWeightLb(pounds);

  return <Typography sx={{ fontSize: "0.9rem" }}>{text}</Typography>;
}
